<script setup lang="ts">
import { useNotifications } from '~/composables/useStates/useNotifications';
import type { INotification } from '~/interfaces/notifications/notifications';
const { $t, $trackEvent } = useNuxtApp();
const site = useSiteStore();

const { getPlaceholder } = useBranding();
const { newNotifications, updateByIds } = useNotifications();
const newNotification = computed<INotification>(
  () => newNotifications.value[0],
);
const action = computed(() => ({
  action: newNotification.value.notificationActions[0].action,
  actionValue: newNotification.value.notificationActions[0].actionValue,
}));

const notificationStyle = computed(
  () => newNotification.value?.notificationStyle,
);

const handleRead = (trackDismissed = true) => {
  const notification = newNotification.value;
  const { notificationId: id } = notification;

  $trackEvent('Notification', 'NOTIFICATION_MARK_AS_READ', { id });
  if (trackDismissed) {
    $trackEvent('Notification', 'NOTIFICATION_DISMISS', { id });
  } else {
    $trackEvent('Notification', 'NOTIFICATION_ACTION_CLICK', {
      id,
      action: action.value.action,
      value: action.value.actionValue,
    });
  }
  updateByIds({
    isRead: true,
    ids: [id],
    updateType: 'Status',
  });

  if (!trackDismissed)
    $trackEvent('Notification', 'NOTIFICATION_ACTION_CLICK', {
      id,
      action: action.value.action,
      value: action.value.actionValue,
    });

  newNotifications.value = newNotifications.value.slice(1);
  site.deactivateModal();
};
const handleAction = (action: { action: string; actionValue: string }) => {
  handleRead(false);
  useMessageHandler(action);
};
onUnmounted(() => (newNotifications.value = newNotifications.value.slice(1)));
</script>
<template>
  <article class="flex flex-col gap-2 text-base-priority">
    <div v-if="notificationStyle !== 'Coupon'">
      <div class="px-3 pt-2 flex flex-col gap-2">
        <DesignSystemLazyImage
          v-if="newNotification?.imageURL || newNotification?.imageUrl"
          :src="newNotification?.imageURL || newNotification?.imageUrl"
          alt="new notification"
          class="text-transparent rounded-lg"
          :placeholder="getPlaceholder('promotionsPlaceholder')"
        />
        <div
          class="text-base-priority text-sm"
          v-html="newNotification?.messageBody"
        />
      </div>
      <div class="flex items-center justify-center gap-2 w-full bg-base p-3">
        <LazyDesignSystemButton
          type="secondary-alternative"
          class="w-full capitalize items-center justify-center"
          rounding="md"
          @click="handleRead"
        >
          {{ $t('dismiss') }}
        </LazyDesignSystemButton>
        <LazyDesignSystemButton
          v-for="(ac, i) in newNotification?.notificationActions"
          :key="i"
          class="w-full capitalize items-center justify-center"
          rounding="md"
          @click="handleAction(ac)"
        >
          {{ $t(ac.actionText) }}
        </LazyDesignSystemButton>
      </div>
    </div>
    <MarketingNotificationsCoupon
      v-else
      class="flex flex-col cursor-pointer"
      :notification="newNotification"
      @click="[
        (newNotifications = newNotifications.slice(1)),
        site.deactivateModal(),
      ]"
    />
  </article>
</template>
